// pages/Archive.js
import React from 'react';
import PageSeo from './seo/PageSeo';
import { FaArrowRight, FaBoxArchive } from 'react-icons/fa6';
import NewsSectionLink from './NewsSectionLink';

import minaiLogo from '../img/minaiLogo.png';
import kreminLogo from '../img/kreminLogo.png';
import vorsklaLogo from '../img/vorsklaLogo.png';
import lisneLogo from '../img/lisneLogo.png';
import realPharmaLogo from '../img/realPharmaLogo.png';
import uzhorodLogo from '../img/uzhorodLogo.png';
import hirnykLogo from '../img/hirnykLogo.png';

import '../styles/Archive.css';

export const archivedClubs = [
  {
    name: 'Реал Фарма',
    image: realPharmaLogo,
    link: '/football-ukraine/real-pharma',
  },
  {
    name: 'Ворскла',
    image: vorsklaLogo,
    link: '/football-ukraine/vorskla',
  },
  {
    name: 'Лісне',
    image: lisneLogo,
    link: '/football-ukraine/lisne',
  },
  {
    name: 'Минай',
    image: minaiLogo,
    link: '/football-ukraine/minai',
  },
  {
    name: 'Кремінь',
    image: kreminLogo,
    link: '/football-ukraine/kremin',
  },
  {
    name: 'ФК Ужгород',
    image: uzhorodLogo,
    link: '/football-ukraine/uzhorod',
  },
  {
    name: 'Гірник-Спорт',
    image: hirnykLogo,
    link: '/football-ukraine/hirnyk-sport',
  },
];

const Archive = () => {
  return (
    <main className="archive-page">
      <PageSeo routePath="/archive" />

      <div className="archive-container">
        <section className="archive-hero">
          <div className="archive-hero__icon">
            <FaBoxArchive />
          </div>

          <div className="archive-hero__content">
            <span className="archive-eyebrow">
              Історія українського футболу
            </span>

            <h1>Архів клубів</h1>

            <p>
              У цьому розділі зібрані новини та матеріали про клуби, які більше
              не представлені в актуальній структурі чемпіонатів або основній
              навігації BigSport.
            </p>

            <p>
              Ми зберігаємо опубліковані матеріали, щоб важливі події,
              результати, трансфери та історія команд залишалися доступними для
              читачів.
            </p>
          </div>
        </section>

        <section className="archive-content">
          <div className="archive-heading">
            <div>
              <span>Збережені сторінки</span>
              <h2>Клуби в архіві BigSport</h2>
            </div>

            <p>
              Оберіть клуб, щоб переглянути всі раніше опубліковані новини та
              матеріали.
            </p>
          </div>

          <div className="archive-grid">
            {archivedClubs.map((club) => (
              <NewsSectionLink
                to={club.link}
                section={club.name}
                key={club.name}
                className="archive-club-card"
                aria-label={`Переглянути архів новин клубу ${club.name}`}
              >
                <div className="archive-club-card__logo">
                  <img src={club.image} alt={`Емблема клубу ${club.name}`} />
                </div>

                <div className="archive-club-card__content">
                  <span className="archive-club-card__label">
                    Архів матеріалів
                  </span>

                  <h3>{club.name}</h3>

                  <p>Новини, результати, трансфери та інші публікації клубу.</p>
                </div>

                <div className="archive-club-card__arrow">
                  <FaArrowRight />
                </div>
              </NewsSectionLink>
            ))}
          </div>
        </section>

        <section className="archive-note">
          <FaBoxArchive />

          <div>
            <h2>Чому клуби потрапляють до архіву?</h2>

            <p>
              Сторінка клубу переноситься до архіву, коли команда більше не
              бере участі в турнірах, які регулярно висвітлює BigSport, припиняє
              виступи або тимчасово втрачає актуальність для основної структури
              сайту.
            </p>

            <p>
              Перенесення до архіву не видаляє матеріали — усі раніше
              опубліковані новини залишаються доступними.
            </p>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Archive;
